var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "popup",
    {
      attrs: { position: "bottom" },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "div",
        { staticClass: "content", staticStyle: { background: "#fff" } },
        [
          _c("div", { staticClass: "header" }, [_vm._v("Bank Name")]),
          _c(
            "div",
            { staticClass: "fieldWrap" },
            [
              _c("field", {
                staticClass: "pickerField",
                attrs: {
                  clearable: "",
                  "right-icon": "search",
                  placeholder: "Search Bank",
                },
                on: { input: _vm.input, focus: _vm.focus },
                model: {
                  value: _vm.inputValue,
                  callback: function ($$v) {
                    _vm.inputValue = $$v
                  },
                  expression: "inputValue",
                },
              }),
            ],
            1
          ),
          _c("picker", {
            ref: "picker",
            staticClass: "commonPicker",
            attrs: {
              "visible-item-count": "5",
              columns: _vm.nowColumns,
              "default-index": _vm.defaultIndex,
              "value-key": "label",
              loading: _vm.loading,
            },
            on: {
              change: _vm.change,
              confirm: _vm.confirm,
              cancel: _vm.cancel,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }